// extracted by mini-css-extract-plugin
export default {"error":"Error_error__R2sIi","appear":"Error_appear__IJTsZ"};